<template>
  <div>
    <h1>投手日报</h1>
    <div class="handle-search">
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        size="small"
        @click="showAdd()"
      >新增</el-button>
      <div class="search-box">
        <div class="searchItem">
          <el-date-picker
            v-model="query.StartTime"
            style="width:140px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="开始日期"
            @change="getData()"
          ></el-date-picker>
          <span>&nbsp;-&nbsp;</span>
          <el-date-picker
            v-model="query.EndTime"
            style="width:140px"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="结束日期"
            @change="getData()"
          ></el-date-picker>
        </div>
        <div class="searchItem">
          <el-select
            v-model="query.ShopUserIds"
            placeholder="请选择日报负责人"
            clearable
            multiple
            size="small"
            @change="getData()"
          >
            <el-option
              v-for="item in shopPeopleArr"
              :key="item.userId"
              :value="item.userId"
              :label="item.userNickName"
            ></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <el-select
            v-model="query.AccountIds"
            placeholder="请选择广告账号"
            clearable
            multiple
            size="small"
            @change="getData()"
          >
            <el-option
              v-for="item in advArr"
              :key="item.id"
              :value="item.id"
              :label="item.accountInfo"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="sumTotal">
        <span>广告投放总金额:$<em class="red">{{totalData.totalAdvertisementFee}}</em></span>
        <span>广告投手:<em class="gray">{{totalData.totalUserNumber}}</em>人</span>
        <span>广告账号:<em class="gray">{{totalData.totalAccountNumber}}</em>个</span>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
      ref="multipleTable"
      :height="tableHeight"
      @row-click="showAdd"
      :header-cell-style="{background:'#F3F4F7',color:'#555'}"
    >
      <el-table-column prop="date" label="时间段"></el-table-column>
      <el-table-column label="店铺负责人" prop="userNickName">
         <template slot-scope="scope">
            <span @click.stop>{{scope.row.userNickName}}</span>
         </template>
      </el-table-column>
      <el-table-column prop="advertisementAccount" label="广告账号">
         <template slot-scope="scope">
            <span @click.stop>{{scope.row.advertisementAccount}}</span>
         </template>
      </el-table-column>
      <el-table-column prop="reportCost" label="FB广告费用（$）"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <el-dialog title="新增数据" :visible.sync="isAddData" width="500px">
      <el-form ref="form" :model="form" label-width="120px" width="40%">
        <el-form-item label="日期">
          <el-date-picker
            size="small"
            v-model="form.date"
            type="date"
            value-format="yyyy-MM-dd"
            :default-value="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="FB广告费用">
          <el-input
            v-model="form.Amount"
            @input="onInput()"
            placeholder="请输入广告费用"
            style="width:220px"
            size="small"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="店铺">
          <el-select v-model="query.b" size="small" style="width:220px">
            <el-option
              v-for="item in shopArr"
              :key="item.value"
              :value="item.value"
              :label="item.text"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="广告账户">
          <el-select v-model="form.AccountId" size="small" style="width:220px">
            <el-option
              v-for="item in advArr"
              :key="item.id"
              :value="item.id"
              :label="item.accountInfo"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddData = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCanSeeReportUserInfo,
  GetOwnAdvertisementAccountShowInfo,
  AddOrUpdateAdvertisementReport,
  AdvertisementReportList
} from "@/utils/api";
import {getYesterday} from '@/utils'
export default {
  data() {
    return {
      isAddData: false,
      searchDate: "",
      currentPage:1,
      tableHeight:0,
      isExpand: false,
      query: {
        pageStart: 1,
        Limit: 20,
        AccountIds: [],
        ShopUserIds: [],
        StartTime: null,
        EndTime: this.getNowTime()
      },
      pageTotal: 50,
      tableData: [],
      form: {
        date: ""
      },
      date:this.getNowTime(),
      shopPeopleArr: [],
      advArr: [],
      totalData:{}
    };
  },
   mounted(){
    this.$nextTick(()=>{
      this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop -135;
    })
  },
  methods: {
    handleSearch() {},
    empty() {},
    getData() {
      AdvertisementReportList(this.query).then(res => {
        if (res) {
          this.tableData = res.pageData.data;
          this.pageTotal = res.pageData.totalData || 10;
          this.totalData = res.totalData;
        }
      });
    },
    onInput() {
      this.$forceUpdate();
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = " 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      return defaultDate;
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageStart", val);
      this.getData();
    },
    sizeChange(val) {
      this.$set(this.query, "Limit", val);
      this.getData();
    },
    getCanSeeReportUserInfo() {
      GetCanSeeReportUserInfo().then(res => {
        this.shopPeopleArr = res;
      });
    },
    getOwnAdvertisementAccountShowInfo() {
      GetOwnAdvertisementAccountShowInfo().then(res => {
        this.advArr = res;
      });
    },
    showAdd(item) {
      if (item) {
        this.form.AccountId = JSON.parse(JSON.stringify(item)).accountId;
        this.form.Amount = JSON.parse(JSON.stringify(item)).reportCost;
        this.form.id = JSON.parse(JSON.stringify(item)).id;
      } else {
        this.form = {
          id: -1,
          date:this.getNowTime()
        };
      }

      this.isAddData = true;
    },
    submitAdd() {
      let { date, AccountId, Amount } = this.form;
      if (!date || !AccountId || !Amount) {
        this.$message.error("日期、广告费用、广告账号不能为空");
        return;
      }

      this.form.Amount = Number(this.form.Amount);
      AddOrUpdateAdvertisementReport(this.form).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.isAddData = false;
          this.getData();
        }
      });
    }
  },
  created() {
    this.getData();
    this.getCanSeeReportUserInfo();
    this.getOwnAdvertisementAccountShowInfo();
  }
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 20px;
  padding: 20px 0;
}
.handle-search {
  background: #f3f3f3;
  border: 1px solid #ddd;
  padding: 10px 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  .search-box {
    display: flex;
    display: -webkit-flex;
    .searchItem {
      margin-right: 20px;
    }
  }
}
.handle-fun {
  margin: 20px 0;
}
.dataView {
  padding-bottom: 20px;
  .el-col {
    .box {
      border: 1px solid #ebedf8;
      background: #fff;
      border-radius: 5px;
      padding: 20px;
      .title {
        font-size: 14px;
      }
      .price {
        font-size: 24px;
        padding-top: 10px;
        span {
          &:first-child {
            font-size: 14px;
          }
        }
      }
    }
  }
}
table {
  width: 100%;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-table__row{
  cursor: pointer;
}
.sumTotal{
  padding:20px;
  background: #f3f3f3;
  border:1px solid #eee;
  border-radius: 5px;
  margin-bottom: 10px;
  span{
    margin-right: 40px;
    &:last-child{
      margin:0;
    }
    .red{
      color:red;
      font-size: 18px;
      font-weight: bold;
    }
    .gray{
      color:#333;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>